import fetchJSON from '../fetchJSON';
import fetchUser from './fetchUser';
import {uniq, sortBy, find, memoize} from 'lodash';

export default memoize(async (): Promise<UserLayer[]> => {
    const url = '/mapsources.json?vector=1&deprecated=1&app=gaiagps-ng-2019&web=1';
    const mapsources = await fetchJSON.memoized(url, {
        credentials: 'same-origin'
    });

    const language = (window.navigator as any).userLanguage || window.navigator.language;
    const languageKey = language === 'en-US' ? 'US' : 'default';
    const membershipKey = (await fetchUser()).hasSubscription ? 'pro_sources' : 'sources';

    const defaultType = mapsources.defaults[languageKey].default_source;
    const types = uniq([defaultType, ...mapsources.defaults[languageKey][membershipKey]]);

    const defaultUserLayers = sortBy(types.map((type: string) => ({
        isVisible: defaultType === type,
        layer: {
            type,
            opacity: 1
        }
    })), 'isVisible');

    if (!find(defaultUserLayers, ({isVisible}) => isVisible)) {
        console.error('No default user layer is visible.');
        defaultUserLayers[0].isVisible = true;
    }

    return defaultUserLayers;
});
